<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'計測方法（データソース）を変更'">
        <template slot="content">
          <div class="text">
          WeRUNでは<b>WeRUN（スマホ）/WeBand/iPhoneヘルスケア/Googlefit</b>等複数のデータソースをサポートしています。<br><br>
          <b>切替え方法１</b><br>
          「メニュー＞計測方法切替」の順で操作します。1日中に複数回切替えたり、ヘルスケア利用している時にヘルスケアにあるデータソースの優先順位を変更したりすると、データ紛失の原因になりますのでご留意ください。
          </div>
          <div class="text">iPhoneの画面</div>
          <img class="picture" src="../assets/images/q_and_a/6_1.png">
          <div class="text">Androidスマホの画面</div>
          <img class="picture" src="../assets/images/q_and_a/6_2.png">
          <div class="text">
          iPhoneヘルスケアに切替える際に、必ず歩数データのアクセスを許可してください。
          </div>
          <img class="picture" src="../assets/images/q_and_a/6_3.png">
          <div class="text">
          <b>切替え方法２</b><br>
          「ホーム＞WeBand」でWeBandとペアリングするとWeBand計測に変わります。「WeBand＞もっと＞デバイス情報」からペアリングを解除すれば自動的にWeRUN計測に変わります。
          </div>
          <img class="picture" src="../assets/images/q_and_a/6.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    name: 'QAndASwitchDataSource',
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesSwitchDataSource.vue